// extracted by mini-css-extract-plugin
export default {"dot":"Dot_dot__cyv1O"};